<template>
  <v-app>
    <template v-if="ready && !!profile">
      <BAppBar
        :profile="profile"
        @toggle="isActiveMenuSystem = !isActiveMenuSystem"
      >
        <template #notifications>
          <NotificationsMenu
            class-button="BAdmin NotificationsMenu__button v-btn--round v-btn--icon v-btn--flat"
          />
        </template>
      </BAppBar>

      <BNavigationDrawer
        v-if="selectedMenuSystem"
        :profile="profile"
        :mini="navigationDrawer.mini"
        :menu="menu"
        :selected-menu-system="selectedMenuSystem"
        @toggle="toggleNavigationDrawerMini"
      />

      <BNavigationDrawerSystems
        v-model="isActiveMenuSystem"
        :mini="navigationDrawer.mini"
        :selected="selectedMenuSystem"
        @select="onSetMenuSystem"
      />
    </template>

    <transition name="fade-slow" mode="out-in">
      <router-view v-if="ready" />
      <BLayoutEmpty v-else loading />
    </transition>

    <portal-target
      name="app-outlet"
    />
  </v-app>
</template>

<script>
import { rootMapper } from '@/store/modules/root'
import { getProjectName } from '@/helpers/projectName'
import { preferenceMapper } from '@/store/modules/preference'

import BLayoutEmpty from '@/components/layouts/BLayoutEmpty.vue'
import BAppBar from './components/BLayoutAuth/BAppBar.vue'
import BNavigationDrawer from './components/BLayoutAuth/BNavigationDrawer.vue'
import BNavigationDrawerSystems from './components/BLayoutAuth/BNavigationDrawerSystems.vue'

export default {
  name: 'BLayoutAdmin',
  components: {
    BLayoutEmpty,
    BAppBar,
    BNavigationDrawer,
    BNavigationDrawerSystems,
    NotificationsMenu: () => import(
      /* webpackChunkName: "notifications.menu" */
      '@/views/Notifications/NotificationsMenu.vue'
    ),
  },
  props: {
    ready: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isActiveMenuSystem: false,
  }),
  computed: {
    ...preferenceMapper.mapState(['navigationDrawer', 'selectedMenuSystem']),
    ...preferenceMapper.mapGetters(['menu']),
    ...rootMapper.mapGetters(['profile']),
  },
  watch: {
    '$vuetify.breakpoint.smAndDown': {
      immediate: true,
      handler(value) {
        const { mini } = this.navigationDrawer
        const isMobileView = !mini && value
        const isTabletView = mini && !value

        if (isMobileView || isTabletView) {
          this.toggleNavigationDrawerMini()
        }
      },
    },
    profile: {
      immediate: true,
      handler(value) {
        if (value?.id && !value.is_superuser && !value.is_admin) {
          // this.$router.push('/lk')
          window.location.replace(process.env.BASE_URL)
        }
      },
    },
  },
  created() {
    document.body.classList.add('layout-admin')
    document.title = getProjectName()
  },
  destroyed() {
    document.body.classList.remove('layout-admin')
  },
  methods: {
    ...preferenceMapper.mapActions([
      'setMenuSystem',
      'toggleNavigationDrawerMini',
    ]),
    onSetMenuSystem(data) {
      if (data?.href) return
      this.setMenuSystem(data)
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-fade.scss"></style>

<style lang="scss">
.BAdmin.NotificationsMenu__button.v-btn--round {
  min-width: 2.375rem;
  min-height: 2.375rem;
  padding: 0.5rem 0;

  .notification-icon svg * {
    fill: white;
  }
}
</style>
